import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
  stateChat: null,
  stateCall: {
    external: false,
    session: null
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
};
